import { faChevronDown, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { AreaOutput } from "../../services/AreasService";

import './multi-select.css';

interface MultiSelectProps {
  disabled?: boolean
  placeholder: string;
  options: AreaOutput[];
  onClickAcao: (dados: any[]) => void;
  optionComAcesso: any[];
}

const MultiSelect = ({ disabled, options, onClickAcao, optionComAcesso, placeholder = "Selecione..." } : MultiSelectProps) => {

  const [selected, setSelected] = useState<AreaOutput[]>(optionComAcesso);
  const [isOpen, setIsOpen] = useState(false);

  const toggleOption = (option: any) => {
    if(selected.some((item) => item.codigo === option.codigo)){  
      setSelected(selected.filter((item) => item.codigo !== option.codigo));
    }
    else {
      setSelected([...selected, option]);
      onClickAcao(option)
    }
  };

  const removeOption = (e: any, option: any) => {
    e.stopPropagation();
    setSelected(selected.filter((item) => item !== option));
    onClickAcao(option)
  };

  useEffect(() => {
    if (disabled === true) {
      setIsOpen(false)
    }
  }, [disabled])

  return (
    <div className={`ms-container ${disabled ? 'disabled-wrapper' : ''}`}>
      <div
        className={`ms-trigger ${disabled ? 'ms-disabled' : ''}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        {selected.length === 0 && <span className="ms-placeholder" >{placeholder}</span>}
        {selected.map(option => (
          <span key={option.codigo} className="ms-badge">
            {option["emp_Nome"] + " - " + option["nome"]}
            <FontAwesomeIcon
              icon={faTimes}
              className="ms-close-icon"
              onClick={(e) => removeOption(e, option)}
            />
          </span>
        ))}
        <div className={`ms-arrow ${isOpen ? 'open' : ''}`}>
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </div>
      {isOpen && (
        <ul className="ms-dropdown">
          {options.filter(x => x.nome !== "TODOS").map(option => (
            <li
              key={option["codigo"]}
              className={`ms-option ${selected.some((item) => item.codigo === option.codigo && item.emp_Codigo === option.emp_Codigo) ? 'selected' : ''}`}
              onClick={() => toggleOption(option)}
            >
              {option["emp_Nome"] + " - " + option["nome"]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MultiSelect;